<template>
    <div>
        <span class="my-search-token"
            v-for="token in tokens">
				<button type="button" class="close" @click="closeToken(token)">&times;</button>
				{{token.label}}<span v-show="token.label && token.value">:</span> {{token.value}}

        </span>

    </div>
</template>

<script>
    import V from 'voUtils/V.js';
    import DateEx from 'voUtils/DateEx.js';

    export default {
    	voVueComponent: 'search-filter-tokens',
    	props: {
    		searchData: Object,
    		searchFields: Object
    	},
    	data: function() {
    		return {
    			tokens: []
    		};
    	},
    	methods: {
    		deleteCookie: function(name) {
    			document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    		},
    		closeToken: function(token) {
    			const suffix = VOFFICE.token.substr(VOFFICE.token.length - 12);
    			const cookieName = 'searchData_' + suffix;
    			for (let i = 0; i < this.tokens.length; i++) {
    				if (this.tokens[i] === token) {
    					let k = this.tokens[i].id;
    					this.searchData[k] = undefined;
    					V.log("deleting token", k);

    					if (k === 'from') {
    						this.searchData.till = undefined;
    						this.searchData.nights_max = undefined;
    						this.searchData.nights_min = undefined;
    						this.deleteCookie(cookieName);
    					} else if (k === 'till') {
    						this.searchData.from = undefined;
    						this.searchData.nights_max = undefined;
    						this.searchData.nights_min = undefined;
    						this.deleteCookie(cookieName);
    					} else if (k === 'pets') {
    						this.searchData.petsCount = undefined;
    					}
    					this.tokens.splice(i);

    					this.$nextTick(function() {
    						this.$emit('updated');
    					});
    					break;

    				}
    			}

    		},
    		update: function(nv) {

    			nv = nv || this.searchData;

    			this.tokens = [];

    			var field, value, v;

    			for (let k in nv) {
    				v = nv[k];

    				field = this.searchFields[k];

    				if (field && v && v !== '0' && v !== 'false' && k !== 'region') { //!_.isBlank(v)

    					value = null;

    					if (k === 'from' || k === 'till') {
    						value = DateEx.formatDate(v);

    					} else if (v !== true && v !== 'true' && k !== 'ids') {
    						//show value
    						if (field.options) {
    							value = field.options[v + ''];
    						} else {
    							value = v;
    						}
    					}

    					this.tokens.push({
    						id: k,
    						label: field.label,
    						value: value
    					});

    				}

    			}

    		}
    	}
    };
</script>

<style scoped>
    .my-search-token {
    	margin: 2px;
    	padding: 2px 6px;
    	display: inline-block;
    	border: 1px solid #ccc;
    	border-radius: 8px;
    	background-color: #fff;
    	font-size: 14px;

    	.close {
    		margin-left: 5px;
    		padding-left: 2px;
    		padding-right: 2px;
    		font-size: 22px;
    		font-weight: 400;
    	}
    }
</style>